import { render, staticRenderFns } from "./EditReference.vue?vue&type=template&id=621961a8&scoped=true&"
import script from "./EditReference.vue?vue&type=script&lang=js&"
export * from "./EditReference.vue?vue&type=script&lang=js&"
import style0 from "./EditReference.vue?vue&type=style&index=0&id=621961a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621961a8",
  null
  
)

export default component.exports